/* App-native visualizer handoff. Does not change fitment authority or legacy IDs. */
(() => {
  'use strict';
  const api=()=>window.TWGFitmentPreview;
  const active=()=>api()?.selectedVehicle()?.query.provider==='twg_app';
  let dialog,body,token=0,opener;
  const node=(tag,text)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;return el;};
  function close(){token++;dialog?.close();opener?.focus();}
  // Never restore a transient handoff dialog from the browser back/forward cache.
  function resetHandoff(){token++;dialog?.close();}
  window.addEventListener('pagehide',resetHandoff);
  window.addEventListener('pageshow',event=>{if(event.persisted)resetHandoff();});
  function surface(){
    if(!dialog){
      dialog=node('dialog');dialog.className='twg-visualizer-dialog';dialog.setAttribute('aria-label','View on your vehicle');
      const heading=node('h2','View on your vehicle'),cancel=node('button','Close');cancel.type='button';cancel.addEventListener('click',close);
      body=node('div');body.setAttribute('aria-live','polite');dialog.append(heading,body,cancel);document.body.append(dialog);
      dialog.addEventListener('cancel',()=>{token++;});
    }
    body.replaceChildren(node('p','Checking visualizer availability…'));
    if(!dialog.open)dialog.showModal();
  }
  async function open(sku='',trigger,onReady){
    if(!active())return;
    opener=trigger||document.activeElement;surface();const ticket=++token;
    const current=()=>ticket===token&&active();
    try{
      if(sku){
        const fit=await api().evaluateSku(sku);
        if(!current())return;
        if(!['fits','caution'].includes(fit.state))throw Error('Select a wheel option returned for this vehicle first.');
        const service=window.MayhemFitmentService,manufacturer=window.MayhemManufacturerFitment;
        if(!service?.wheels||!manufacturer?.hasPreview)throw Error('The wheel preview is unavailable on this page.');
        const wheels=await service.wheels([sku]),wheel=wheels.get(String(sku).toUpperCase());
        if(!current())return;
        if(wheel?.Pn!==sku||!manufacturer.hasPreview(wheel))throw Error('A visualizer image is not available for this wheel.');
      }
      const binding=await api().resolveVisualizerVehicle();if(!current())return;
      const navigate=id=>{
        if(!current())return;
        if(typeof onReady==='function'){close();onReady(id);return;}
        const url=new URL('/pages/visualizer',location.origin);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
        if(sku)url.hash='/autosync-visualizer/visualizer?'+new URLSearchParams({vehicle_id:id,wheel_pn:sku});
        else url.searchParams.set('vehicle_id',id);
        resetHandoff();
        location.assign(url.href);
      };
      const chosen=api().visualizerVehicleId();
      if(chosen){navigate(chosen);return;}
      if(binding.state!=='choose_body'||!binding.candidates.length)throw Error('We could not match this vehicle in the visualizer. Your wheel fitment selection is unchanged.');
      body.replaceChildren(node('p','Choose the body and bed shown in your preview.'));
      const label=node('label','Vehicle configuration '),select=node('select');select.setAttribute('aria-label','Vehicle configuration');
      const placeholder=node('option','Select body / bed');placeholder.value='';select.append(placeholder);
      for(const choice of binding.candidates){const option=node('option',choice.label);option.value=choice.id;select.append(option);}
      const go=node('button','Open visualizer');go.type='button';go.disabled=true;
      select.addEventListener('change',()=>{go.disabled=!select.value;});
      go.addEventListener('click',()=>{if(!current()||!select.value)return;api().selectVisualizerBody(select.value);navigate(select.value);});
      label.append(select);body.append(label,go);
    }catch(error){if(current())body.replaceChildren(node('p',error.message||'Visualizer is temporarily unavailable. Please try again.'));}
  }
  window.TWGOpenVisualizer=open;
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-twg-visualizer-sku], a[href*="/pages/visualizer"]');
    if(!target||!active())return;
    if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    event.preventDefault();event.stopImmediatePropagation();
    const url=target.href?new URL(target.href,location.origin):null;
    const hash=url?new URLSearchParams(url.hash.split('?')[1]||''):null;
    open(target.dataset.twgVisualizerSku||hash?.get('wheel_pn')||url?.searchParams.get('wheel_pn')||'',target);
  },true);
  const badgeStates=new WeakMap();
  const syncBadges=(host,sku,state)=>{
    const selection=api()?.selectedVehicle();
    const enabled=active()&&sku&&['fits','caution'].includes(state);
    const previous=badgeStates.get(host);
    if(!enabled){previous?.element?.remove();badgeStates.delete(host);return;}
    const key=JSON.stringify([selection.query,sku,state]);
    if(previous?.key===key && (!previous.element || previous.element.parentElement===host))return;
    previous?.element?.remove();
    const record={key,element:null};badgeStates.set(host,record);
    api().evaluateSku(sku).then(result=>{
      if(badgeStates.get(host)!==record||!host.isConnected||JSON.stringify(api()?.selectedVehicle()?.query)!==JSON.stringify(selection.query))return;
      if(!['fits','caution'].includes(result.state)||result.rawApplication?.item!==sku)return;
      const card=host.closest('.mayhem-wheel-card');
      const badges=[];
      const accessories=result.rawApplication.accessories;
      if(accessories?.direct_fit===true)badges.push(['Direct fit','direct','Hub-centric with a matching lug seat. Check the other fitment conditions shown.']);
      const types={Standard:['Factory size (OE)','standard'],Staggered:['Staggered','standard'],Upstep:['Plus size','plus'],'Minus Size':['Minus size','minus'],Lifted:['Lifted','lifted']};
      for(const type of new Set(result.fitmentTypes||[]))if(types[type])badges.push([...types[type],type==='Lifted'?'Lifted application listed; see installation requirements for your setup.':'']);
      if(accessories?.hub_ring_needed===true)badges.push(['Hub ring required','ring',accessories.note||'']);
      if(!badges.length)return;
      const group=node('div');group.className='twg-fitment-badges';group.dataset.twgFitmentBadges=sku;group.setAttribute('role','group');group.setAttribute('aria-label','Fitment for '+sku);
      for(const [label,kind,description] of badges){const badge=node('span',label);badge.className='twg-fitment-badge twg-fitment-badge--'+kind;if(description)badge.title=description;group.append(badge);}
      if(card&&(accessories?.hub_ring_needed===true||accessories?.note?.trim()||result.accessoryNotes?.length||result.fitmentTypes?.includes('Lifted'))){
        const destination=card.querySelector('.mayhem-wheel-card__link');
        if(destination){const link=node('a','Installation requirements');link.href=destination.href;link.className='twg-card-installation-link';group.append(link);}
      }
      record.element=group;host.append(group);
    }).catch(()=>{});
  };
  const sync=()=>{
    const enabled=active();
    const hosts=[...document.querySelectorAll('.mayhem-wheel-card [data-mayhem-card-fitment]')].map(badge=>({host:badge.closest('.mayhem-wheel-card').querySelector('.mayhem-wheel-card__footer'),sku:badge.dataset.sku,state:badge.dataset.state}));
    document.querySelectorAll('[data-mayhem-specs] tr[data-sku]').forEach(row=>hosts.push({host:row.querySelector('td[data-spec-fitment-column]'),sku:row.dataset.sku,state:row.dataset.fitmentState}));
    for(const {host,sku,state} of hosts){
      if(!host)continue;
      syncBadges(host,sku,state);
      let button=host.querySelector('[data-twg-generated-preview]');
      if(!enabled||!sku||!['fits','caution'].includes(state)){button?.remove();continue;}
      if(!button){button=node('button','View on vehicle');button.type='button';button.className='twg-view-on-vehicle';button.dataset.twgGeneratedPreview='true';host.append(button);}
      if(button.dataset.twgVisualizerSku!==sku)button.dataset.twgVisualizerSku=sku;
    }
  };
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;sync();});};
  const start=()=>{
    new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-state','data-sku','data-fitment-state']});
    window.addEventListener('twg:vehicle-changed',()=>{if(dialog?.open)close();schedule();});sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
